import { createFileRoute } from "@tanstack/react-router";
import LegalPage from "@/components/LegalPage";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — Backland" },
      {
        name: "description",
        content:
          "How Backland and our reservation partner Mews collect, use, and protect your personal data.",
      },
      { property: "og:title", content: "Privacy Policy — Backland" },
      {
        property: "og:description",
        content: "How we handle your personal data at Backland.",
      },
      { property: "og:url", content: "https://www.travelbackland.com/privacy" },
    ],
    links: [{ rel: "canonical", href: "https://www.travelbackland.com/privacy" }],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <LegalPage eyebrow="Legal" title="Privacy Policy">
      <h2>Data Privacy</h2>
      <p>
        By entering your email we do add you to our newsletter, which you can unsubscribe
        from at any time.
      </p>

      <h2>Mews</h2>
      <p>Our property uses Mews to provide online reservation services.</p>
      <p>
        Mews/Backland respects your privacy and is committed to protecting it. Your personal
        information is collected and stored to facilitate online reservations with our
        property. Basic information concerning your visit to this site is used by
        Mews/Backland to improve its service. Your data is never shared with unauthorized
        outside parties or sold.
      </p>
      <p>
        Mews has complied with the foundation principles of GDPR and is proud to be GDPR
        compliant with regards to breach notifications, right to access, right to be
        forgotten, data portability, privacy by design, and data protection officers.
      </p>

      <h2>Data Collected</h2>
      <p>
        We process customer contact details such as your name, email, and phone number
        directly from you when you make a booking. We also process some of the
        communications sent by this property to provide services to you and to carry out
        necessary functions of our business as a service provider.
      </p>

      <h2>How we share personal data</h2>
      <p>
        First things first: we do not sell your personal data. We also do not allow any
        personal data to be used by third parties for their own marketing purposes (except
        in cases where you explicitly request or provide consent for us to do so).
      </p>
      <p>
        However, we do need to share it in some circumstances. These may be to provide you
        services (e.g., spa services, activities, or sending an email), or when necessary
        for our suppliers to provide services to us, or for another reason listed here, or
        share personal data for cross-context behavioral advertising.
      </p>

      <h2>Cookies and tracking technology</h2>
      <p>
        Mews uses a third party app to give you the option to customize your cookie
        settings. The common information-gathering tools such as cookies, web beacons,
        pixels and other similar tracking technologies automatically collect information as
        you navigate our websites, our services or when you interact with emails the
        property sends to you.
      </p>
      <p>
        A cookie is a piece of data contained in a very small text file that is stored in
        your browser or elsewhere on your hard drive. Cookies allow us to identify your
        device as you navigate our websites or your account. This makes navigating and
        interacting with our websites or your account more efficient, easy and meaningful
        for you.
      </p>
      <p>
        By themselves, cookies do not identify you specifically. Rather, they recognize your
        web browser. We use session cookies. Session cookies are cookies that disappear from
        your computer or browser when you turn off your computer.
      </p>

      <h2>Security information</h2>
      <p>
        While there is no such thing as perfect security, we are committed to maintaining
        reasonable and appropriate security measures to ensure that your personal data is
        protected both online and offline.
      </p>
      <p>
        Mews Payment uses industry-standard encryption to protect your personal and payment
        information during and after your reservation. After your reservation is complete,
        the system removes your credit card information to prevent theft or disclosure. Mews
        Payment meets or exceeds rigorous industry standards for protecting credit card
        information and is PCI compliant. This PCI compliance has been verified by an
        external auditor.
      </p>

      <h2>Global Privacy Compliance</h2>
      <p>
        Mews is a global company with customers and offices all around the world. As such,
        our approach to privacy compliance is a global one. No matter where you are located,
        whether in the United States, the European Economic Area (EEA), the United Kingdom
        (UK), Latin America, or the Asia-Pacific region, we remain committed to abiding by
        all applicable data protection laws.
      </p>

      <h2>Changes to our Privacy Notice</h2>
      <p>
        We may change this Privacy Notice from time to time, and if we do, the most current
        version will be available with the date indicating when it was last updated.
      </p>
    </LegalPage>
  );
}
